import api from "@/config/apiConfig"

class CampaignsController {
  async index() {
    try {
      const response = await api.get("/campaigns");
      return response.data;
    } catch (error) {
      console.error("Erro no CampaignsController.index: ", error);
      throw error;
    }
  }

  async create(req) {
    try {
      const response = await api.post("/campaigns", req);
      return response.data;
    } catch (error) {
      console.error("Erro no CampaignsController.create: ", error);
      throw error;
    }
  }

  async show(id) {
    try {
      const response = await api.get(`/campaigns/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro no CampaignsController.show: ", error);
      throw error;
    }
  }

  async update(id, req) {
    try {
      const response = await api.patch(`/campaigns/${id}`, req);
      return response.data;
    } catch (error) {
      console.error("Erro no CampaignsController.update: ", error);
      throw error;
    }
  }

  async remove(id) {
    try {
      const response = await api.delete(`/campaigns/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro no CampaignsController.remove: ", error);
      throw error;
    }
  }

  async addContacts(id, contacts) {
    try {
      const response = await api.post(`/campaigns/${id}/contacts`, { contacts });
      return response.data;
    } catch (error) {
      console.error("Erro no CampaignsController.addContacts: ", error);
      throw error;
    }
  }

  async startCampaign(id) {
    try {
      const response = await api.post(`/campaigns/${id}/start`);
      return response.data;
    } catch (error) {
      console.error("Erro no CampaignsController.startCampaign: ", error);
      throw error;
    }
  }

  async pauseCampaign(id) {
    try {
      const response = await api.post(`/campaigns/${id}/pause`);
      return response.data;
    } catch (error) {
      console.error("Erro no CampaignsController.pauseCampaign: ", error);
      throw error;
    }
  }

  async removeContact(campaignId, contactId) {
    try {
      const response = await api.delete(`/campaigns/${campaignId}/contacts/${contactId}`);
      return response.data;
    } catch (error) {
      console.error("Erro no CampaignsController.removeContact: ", error);
      throw error;
    }
  }
}

export default new CampaignsController();
